module.exports = __webpack_public_path__ + "img/simon-fraser-university.06b8f41e.png";